import { useAssetParams } from '../../../hooks/useAssetParams'
import { useOutletContext } from 'react-router-dom'
import { safeDecodeFromUrl } from '../../../utils'
import { ScoopTheme } from '../../Insights/Style'
import ReactECharts from 'echarts-for-react'
import { buildPackedCircleOption } from '../Insights/ML/PackedCircleOption'
import styles from './ClusterAsset.module.scss'

export const ClusterAsset = () => {
    const { params } = useAssetParams()
    const outletContext = useOutletContext()

    const getClusterOption = () => {
        const option = buildPackedCircleOption(
            JSON.parse(safeDecodeFromUrl(params?.object)),
            outletContext.containerSize.width,
            outletContext.containerSize.height
        )
        option.animation = false
        return option
    }

    return (
        params?.object && (
            <div id={'chat-screenshot-container'} className={styles.container}>
                <ReactECharts
                    className={styles.chart}
                    option={getClusterOption()}
                    notMerge={true}
                    lazyUpdate={true}
                    theme={ScoopTheme}
                />
            </div>
        )
    )
}
